import { render, staticRenderFns } from "./fabu.vue?vue&type=template&id=43792198&scoped=true"
import script from "./fabu.vue?vue&type=script&lang=js"
export * from "./fabu.vue?vue&type=script&lang=js"
import style0 from "./fabu.vue?vue&type=style&index=0&id=43792198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43792198",
  null
  
)

export default component.exports